import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { QuoteProvider } from "@/components/QuoteDialog";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import Traslochi from "@/pages/Traslochi";
import Trasporti from "@/pages/Trasporti";
import SpedizioneMoto from "@/pages/SpedizioneMoto";
import Azienda from "@/pages/Azienda";
import Recensioni from "@/pages/Recensioni";
import Contatti from "@/pages/Contatti";
import { Seo } from "@/components/Seo";

const SEO = {
  "/": ["AXAL Logistics — Trasporti, Spedizioni e Traslochi a Roma", "Trasporti, spedizioni, traslochi e spedizione moto per privati e aziende, da Roma verso tutta Italia. Richiedi un preventivo gratuito ad AXAL Logistics."],
  "/servizi": ["Servizi di trasporto, traslochi e deposito | AXAL Logistics", "Trasporti nazionali, traslochi, spedizione moto, spedizioni, deposito merci e autoscala con operatore. Un unico partner per privati e aziende in tutta Italia."],
  "/traslochi": ["Traslochi a Roma e in tutta Italia | AXAL Logistics", "Trasloco completo con smontaggio, imballaggio, fornitura scatole, facchinaggio, rimontaggio, autoscala e deposito. Operatori qualificati e mezzi propri AXAL."],
  "/trasporti": ["Trasporti nazionali e groupage in Italia | AXAL Logistics", "Trasporti dedicati e groupage per merci e mobilio sulle principali tratte italiane. Servizio Standard, Espresso, Urgente o dedicato su richiesta."],
  "/spedizione-moto": ["Spedizione moto e scooter in tutta Italia | AXAL Logistics", "Ritiro e consegna a domicilio di moto, scooter e motorini con mezzi e personale AXAL. Scegli tra servizio Standard, Espresso, Urgente o Dedicato."],
  "/azienda": ["Chi siamo: azienda, flotta e metodo | AXAL Logistics", "AXAL Logistics SRL: soluzioni professionali per trasporti, spedizioni e traslochi, con mezzi propri, assistenza dedicata e copertura nazionale da Roma."],
  "/recensioni": ["Recensioni dei clienti | AXAL Logistics", "Cosa dicono i clienti di AXAL Logistics su traslochi, trasporti e spedizioni moto. Leggi le recensioni e scopri il nostro servizio."],
  "/contatti": ["Contatti e preventivo gratuito | AXAL Logistics", "Contatta AXAL Logistics: cellulare e WhatsApp +39 324 551 5015, telefono fisso +39 06 92949896, email axal.log@gmail.com. Preventivo gratuito."],
};

const RouteSeo = () => {
  const { pathname } = useLocation();
  const [title, description] = SEO[pathname] || SEO["/"];
  return <Seo title={title} description={description} path={SEO[pathname] ? pathname : "/"} />;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <QuoteProvider>
          <ScrollToTop />
          <RouteSeo />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/traslochi" element={<Traslochi />} />
              <Route path="/trasporti" element={<Trasporti />} />
              <Route path="/spedizione-moto" element={<SpedizioneMoto />} />
              <Route path="/azienda" element={<Azienda />} />
              <Route path="/recensioni" element={<Recensioni />} />
              <Route path="/contatti" element={<Contatti />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </QuoteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
